import { Form, Input, List, Tabs } from '@bynder/design-system';
import { Translate, useTranslate } from '@bynder/localization';
import { useActiveSection } from '../../../../queries/guides';
import {
  SECTION_CONTENT_SPACING_LARGE,
  SECTION_CONTENT_SPACING_MEDIUM,
  SECTION_CONTENT_SPACING_SMALL,
} from '../../../../constants/sections';
import { useSectionMutations } from '../../../../mutations/sections';
import { useDebouncedCallback } from 'use-debounce';
import { useEffect, useState } from 'react';
import { INSPECTOR_DEBOUNCE_DELAY } from '../constants';

export const SectionWidgetSpacingEditor = () => {
  const { translate } = useTranslate();
  const { activeSection } = useActiveSection();
  const { editSectionContentSpacing } = useSectionMutations();

  const [spacing, setSpacing] = useState(
    activeSection?.appearance.contentSpacing,
  );

  const debouncedChangeSpacing = useDebouncedCallback(
    option =>
      editSectionContentSpacing.mutate({
        sectionId: activeSection.id,
        contentSpacing: option,
      }),
    INSPECTOR_DEBOUNCE_DELAY,
  );
  const handleChangeSpacing = (option: number) => {
    setSpacing(option);
    if (option !== spacing) {
      debouncedChangeSpacing(option);
    }
  };
  useEffect(() => {
    setSpacing(activeSection?.appearance.contentSpacing);
  }, [activeSection?.appearance.contentSpacing]);

  return (
    <>
      <List.Item>
        <Translate id="SECTION_INSPECTOR.SECTION_CONTENT_SPACING" />
      </List.Item>

      <Form.Row>
        <Form.Group>
          <Input
            data-testid="spacing-input"
            id="label-suffix"
            value={spacing.toString()}
            type="number"
            suffix="px"
            onChange={value => handleChangeSpacing(Number(value))}
          />
        </Form.Group>
        <Tabs variant="clean">
          <Tabs.Tab
            data-testid="spacing-small"
            label={translate('SECTION_INSPECTOR.SECTION_CONTENT_SPACING_SMALL')}
            isActive={spacing === SECTION_CONTENT_SPACING_SMALL}
            onClick={() => handleChangeSpacing(SECTION_CONTENT_SPACING_SMALL)}
          />
          <Tabs.Tab
            data-testid="spacing-medium"
            label={translate(
              'SECTION_INSPECTOR.SECTION_CONTENT_SPACING_MEDIUM',
            )}
            isActive={spacing === SECTION_CONTENT_SPACING_MEDIUM}
            onClick={() => handleChangeSpacing(SECTION_CONTENT_SPACING_MEDIUM)}
          />
          <Tabs.Tab
            data-testid="spacing-large"
            label={translate('SECTION_INSPECTOR.SECTION_CONTENT_SPACING_LARGE')}
            isActive={spacing === SECTION_CONTENT_SPACING_LARGE}
            onClick={() => handleChangeSpacing(SECTION_CONTENT_SPACING_LARGE)}
          />
        </Tabs>
      </Form.Row>
    </>
  );
};
